import * as React from 'react'
import { cn } from '../../lib/utils'

export interface PanelHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
	/** Left side — e.g. sidebar toggle + vertical separator */
	leading?: React.ReactNode
	/** Center — usually a <Breadcrumb> or <h1> */
	title?: React.ReactNode
	/** Right side — avatar, notifications, profile menu */
	actions?: React.ReactNode
}

/**
 * Horizontal panel header with a leading slot, title slot (flex-1) and actions slot.
 * Matches Figma "Header" pattern — 64px tall by default, bottom border.
 */
const PanelHeader = React.forwardRef<HTMLDivElement, PanelHeaderProps>(
	({ className, leading, title, actions, children, ...props }, ref) => (
		<div
			ref={ref}
			className={cn(
				'flex h-16 items-center gap-2 border-b border-(--color-border) bg-(--color-background) px-4',
				className
			)}
			{...props}
		>
			{leading && <div className="flex items-center gap-2 shrink-0">{leading}</div>}
			<div className="flex flex-1 items-center min-w-0">{title ?? children}</div>
			{actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
		</div>
	)
)

PanelHeader.displayName = 'PanelHeader'
export { PanelHeader }
